import numeral from "numeral"
//Apply global settings here
export default numeral;